<template>
    <div class="failure" ref="failure">
        <img style="width:100%" src="/static/img/shixiao.png" alt="">
        <p class="text1">此链接地址已失效，请重新获取链接!</p>
        <p class="text2">版权所有：深圳市华商数据科技有限公司 Copyright @ 2017 All Rights Reserved</p>
    </div>
</template>

<script>
    export default {
        data(){
            return {

            }
        },
        created(){
            this.$store.state.isinvitation = false;
        },
        mounted(){
            let H = window.innerHeight;
            this.$refs.failure.style.height = H +'px';
            this.$store.state.isinvitation = false;
        },
        destroyed(){
            this.$store.state.isinvitation = true
        },
    }
</script>

<style scoped>
.failure {
    overflow: hidden;
    margin-top: 80px;
}
p {
    text-align: center;
    position: absolute;
    width: 100%;
}
.text1 {
    font-family: PingFangSC-Regular;
    font-size: 2.5rem;
    color: #344A69;
    letter-spacing: 0;
    top: 60%;
    line-height: 40px;
}
.text2 {
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #7C93AD;
    letter-spacing: 0;
    bottom: 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/conenter/failure.vue